var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert"},[_c('p',{staticClass:"body-2 mrg-bottom-0 alert__message ellipsis",attrs:{"title":_vm.message}},[_vm._v(" "+_vm._s(_vm.message)+" ")]),_c('a',{attrs:{"disabled":_vm.closable},on:{"click":function($event){return _vm.$emit('close')}}},[_c('a-icon',{attrs:{"type":"close"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }